// extracted by mini-css-extract-plugin
export default {"img":"MultiCarrusel_img__QpWer","imgItem":"MultiCarrusel_imgItem__e97+p","aiCard":"MultiCarrusel_aiCard__rhsn8"};